import {omit} from '@packages/utilities/key-map';

/**
 * Is the passed in node renderable?
 *
 * If a child is falsey it will not produce
 * any rendered output unless it is the number `0`.
 *
 * @param  {ReactNode} node
 * @return {Boolean}
 */
const isRenderableNode = (node: any) => Boolean(node) || node === 0;

/**
 * Determines if any of the children are renderable.
 *
 * The `children` prop is usually an array but can be a single child
 * if it’s the only one.
 *
 * @param  {ReactProps}
 * @return {Boolean}
 */
// @ts-expect-error - TS2339 - Property 'children' does not exist on type 'ReactNode'.
export const hasRenderableChildren = ({children}: React.ReactNode): boolean =>
  Array.isArray(children)
    ? Boolean(children.length) && children.some(isRenderableNode)
    : isRenderableNode(children);

export const omitChildren: (arg2: {[key: string]: any}) => {
  [key: string]: any;
} = omit(['children']);
